import { render } from "./editor.vue?vue&type=template&id=63355eb6"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=63355eb6&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__